import React from 'react';
import { SvgProps } from 'models/Icon';

export default (props: SvgProps) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="transparent"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M6.5 2.5L10 6L6.5 9.5M2.5 2.5L6 6L2.5 9.5" />
  </svg>
);
